import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";
import { ValidationErrors } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ERROR_KEYS, VALIDATION_MESSAGE } from "../../constants";

@Component({
	selector: "app-validation-errors",
	templateUrl: "./validation-errors.component.html",
	styleUrls: ["./validation-errors.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValidationErrorsComponent implements OnChanges {

	@Input() errors: ValidationErrors;
	@Input() label: any;

	requiredError: string;
	invalidEmailError: string;
	shortLengthError: string;
	longLengthError: string;
	passwordNotMatchError: string;
	digitsNotAllowedError: string;
	invalidPasswordError: string;
	invalidWebsiteError: string;
	incompleteEmailError: string;
	minValueError: string;
	invalidOrganizationError: string;
	invalidFirstName: string;
	invalidLastName: string;
	specialCharacterRequired: string;
	digitRequired: string;
	uppercaseLetterRequired: string;
	lowercaseLetterRequired: string;
	spaceInvalid: string;
	deadlineInvalid: string;
	websiteInvalidError: string;
	invalidSpecialCharacter: string;
	activateTenderDateInvalid:string;
	passwordNotValid: string;
	passwordNotMatch: string;

	constructor(
		private translationService: TranslateService
	) { }

	ngOnChanges() {
		if (this.errors && this.errors["required"]) {
			if (this.label === "email") {
				this.getErrorText(ERROR_KEYS.REQUIRE.EMAIL).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "firstName") {
				this.getErrorText(ERROR_KEYS.REQUIRE.FIRST_NAME).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "lastName") {
				this.getErrorText(ERROR_KEYS.REQUIRE.LAST_NAME).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "organization") {
				this.getErrorText(ERROR_KEYS.REQUIRE.ORGANIZATION).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "username") {
				this.getErrorText(ERROR_KEYS.REQUIRE.USERNAME).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "password") {
				this.getErrorText(ERROR_KEYS.REQUIRE.PASSWORD).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "confirmPassword") {
				this.getErrorText(ERROR_KEYS.REQUIRE.CONFIRM_PASSWORD).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "name" || "street" || "c/o" || "streetNo" || "region" || "zipCode" || "country") {
				this.getErrorText(ERROR_KEYS.REQUIRE.NEW_OR_EDIT_ADDRESS).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "deadline") {
				this.getErrorText(ERROR_KEYS.REQUIRE.DEADLINE).subscribe(response => {
					this.requiredError = response;
				});
			} else if (this.label === "customReason") {
				this.getErrorText(ERROR_KEYS.REQUIRE.CUSTOMREASON).subscribe(response => {
					this.requiredError = response;
				});
			}
		}

		if (this.errors && this.errors["pattern"]) {
			if (this.label === "website" || this.label === "termsAndConditions") {
				this.getErrorText(ERROR_KEYS.INVALID.WEBSITE).subscribe(response => {
					this.websiteInvalidError = response;
				});
			}
		}

		if (this.errors && this.errors["invalidEmail"]) {
			this.getErrorText(ERROR_KEYS.INVALID.EMAIL).subscribe(response => {
				this.invalidEmailError = response;
			});
		}

		if (this.errors && this.errors["email"]) {
			this.getErrorText(ERROR_KEYS.INVALID.EMAIL).subscribe(response => {
				this.invalidEmailError = response;
			});
		}

		if (this.errors && this.errors["incompleteEmail"]) {
			this.getErrorText(ERROR_KEYS.INCORRECT.EMAIL).subscribe(response => {
				this.incompleteEmailError = response;
			});
		}

		if (this.errors && this.errors["invalidPassword"]) {
			this.getErrorText(ERROR_KEYS.INVALID.PASSWORD).subscribe(response => {
				this.invalidPasswordError = response;
			});
		}

		if (this.errors && this.errors["minlength"]) {
			if (this.label === "zipCode") {
				this.getErrorText(ERROR_KEYS.MIN_LENGTH.ZIP_CODE).subscribe(response => {
					this.shortLengthError = response + ". " + this.errors["minlength"].requiredLength;
				});
			} else if (this.label === "password") {
				this.getErrorText(ERROR_KEYS.MIN_LENGTH.PASSWORD).subscribe(response => {
					this.shortLengthError = response + ". " + this.errors["minlength"].requiredLength;
				});
			} else if (this.label === "organization") {
				this.getErrorText(ERROR_KEYS.MIN_LENGTH.ORGANIZATION_NAME).subscribe(response => {
					this.shortLengthError = response;
				});
			} else {
				this.getErrorText(ERROR_KEYS.MIN_LENGTH.GENERIC).subscribe(response => {
					this.shortLengthError = response + ". " + this.errors["minlength"].requiredLength;
				});
			}
		}

		if (this.errors && this.errors["invalidOrganization"]) {
			this.getErrorText(ERROR_KEYS.INVALID.ORGANIZATION).subscribe(response => {
				this.invalidOrganizationError = response;
			});
		}

		if (this.errors && this.errors["min"]) {
			if (this.label === "EAN" || "defaultPrice" || "packageUnit" || "unit") {
				this.getErrorText(ERROR_KEYS.MIN_VALUE.PRICE).subscribe(response => {
					this.minValueError = response;
				});
			}
		}

		if (this.errors && this.errors["maxlength"]) {
			if (this.label === "zipCode") {
				this.getErrorText(ERROR_KEYS.MAX_LENGTH.ZIP_CODE).subscribe(response => {
					this.longLengthError = response + ". " + this.errors["maxlength"].requiredLength;
				});
			}
			if (this.label === "description") {
				this.getErrorText(ERROR_KEYS.MAX_LENGTH.DESCRIPTION).subscribe(response => {
					this.longLengthError = response + ". " + this.errors["maxlength"].requiredLength;
				});
			} else {
				this.getErrorText(ERROR_KEYS.MAX_LENGTH.GENERIC).subscribe(response => {
					this.longLengthError = response + ". " + this.errors["maxlength"].requiredLength;
				});
			}
		}

		if (this.errors && this.errors["incorrect"]) {
			this.getErrorText(ERROR_KEYS.INCORRECT.CONFIRM_PASSWORD).subscribe(response => {
				this.passwordNotMatchError = response;
			});
		}

		if (this.errors && this.errors["digitsNotAllowed"]) {
			this.getErrorText(ERROR_KEYS.INVALID.DIGITS_NOT_ALLOWED).subscribe(response => {
				this.digitsNotAllowedError = response;
			});
		}

		if (this.errors && this.errors["invalidFirstName"]) {
			this.getErrorText(ERROR_KEYS.INVALID.FIRST_NAME).subscribe(response => {
				this.invalidFirstName = response;
			});
		}

		if (this.errors && this.errors["invalidLastName"]) {
			this.getErrorText(ERROR_KEYS.INVALID.LAST_NAME).subscribe(response => {
				this.invalidLastName = response;
			});
		}

		if (this.errors && this.errors["specialCharacterRequired"]) {
			this.getErrorText(ERROR_KEYS.INVALID.SPECIAL_CHARACTER_REQUIRED).subscribe(response => {
				this.specialCharacterRequired = response + ' (' + VALIDATION_MESSAGE.SPECIAL_CHARACTERS + ')';
			});
		}

		if (this.errors && this.errors["invalidSpecialCharacter"]) {
			this.getErrorText(ERROR_KEYS.INVALID.INVALID_SPECIAL_CHARACTER).subscribe(response => {
				this.invalidSpecialCharacter = response;
			});
		}

		if (this.errors && this.errors["digitRequired"]) {
			this.getErrorText(ERROR_KEYS.INVALID.DIGIT_REQUIRED).subscribe(response => {
				this.digitRequired = response;
			});
		}

		if (this.errors && this.errors["uppercaseRequired"]) {
			this.getErrorText(ERROR_KEYS.INVALID.UPPERCASE_LETTER_REQUIRED).subscribe(response => {
				this.uppercaseLetterRequired = response;
			});
		}

		if (this.errors && this.errors["lowercaseRequired"]) {
			this.getErrorText(ERROR_KEYS.INVALID.LOWERCASE_LETTER_REQUIRED).subscribe(response => {
				this.lowercaseLetterRequired = response;
			});
		}

		if (this.errors && this.errors["spaceInvalid"]) {
			this.getErrorText(ERROR_KEYS.INVALID.SPACE).subscribe(response => {
				this.spaceInvalid = response;
			});
		}

		if (this.errors && this.errors["dateOfPast"]) {
			this.getErrorText(ERROR_KEYS.INVALID.DEADLINE).subscribe(response => {
				this.deadlineInvalid = response;
			});
		}
		if (this.errors && this.errors["activatingTenderDateIsPastDate"]) {
			this.getErrorText(ERROR_KEYS.INVALID.ACTIVATE_TENDER_ON).subscribe(response => {
				this.activateTenderDateInvalid = response;
			});
		}
		if (this.errors && this.errors["dateLessThanStartingDate"]) {
			this.getErrorText(ERROR_KEYS.INCORRECT.DEADLINE).subscribe(response => {
				this.deadlineInvalid = response;
			});
		}
		if (this.errors && this.errors["dateGreaterThanDeadlineDate"]) {
			this.getErrorText(ERROR_KEYS.INCORRECT.ACTIVATE_TENDER_ON).subscribe(response => {
				this.activateTenderDateInvalid = response;
			});
		}
		if (this.errors && this.errors["passwordNotValid"]) {
			this.getErrorText(ERROR_KEYS.INVALID.SIGN_UP_PASSWORD).subscribe(response => {
				this.passwordNotValid = response ;
			});
		}
		if (this.errors && this.errors["confirmPasswordNotMatch"]) {
			this.getErrorText(ERROR_KEYS.INVALID.PASSWORD_NOT_MATCH).subscribe(response => {
				this.passwordNotMatch = response ;
			});
		}
	}


	/**
	 * This will return the error test in currently selected language
	 * @param key : error key string
	 */
	getErrorText(key: string) {
		return this.translationService.get(`global.errors.${key}`);
	}
}
